import { Box, Flex, IconButton, Input, InputGroup, InputRightElement } from '@chakra-ui/react';

import { isDefined, isNotDefined, isNotEmpty } from '@enterprise/core';
import { NumberFormat, Xmark } from '@enterprise/ui';

import type { TargetInputCellProps } from './types/target-input-cell.props';

import { useTargetInputCellConfiguration } from './hooks/target-input-cell-configuration.hook';

const TargetInputCell = ({ context, data, node, value }: TargetInputCellProps) => {
  const { handleBlur, handleChange, handleClear, localValue } = useTargetInputCellConfiguration({ context, data });

  if (node.level === -1) {
    if (isNotDefined(value) || value === 0) {
      return null;
    }

    return (
      <Box
        as="span"
        color={context.isOverThreshold ? 'red.500' : undefined}>
        <NumberFormat value={value} />
      </Box>
    );
  }

  return (
    <Flex
      align="center"
      gap={1}
      h="full"
      w="full">
      <InputGroup>
        <Input
          bg="white"
          className="hide-spin-buttons"
          lineHeight="initial!"
          max={data?.firstOutput}
          min={0}
          onBlur={handleBlur}
          onChange={handleChange}
          pattern="[0-9]*"
          placeholder="----"
          type="number"
          value={localValue}
        />
        {isDefined(localValue) && isNotEmpty(localValue) && (
          <InputRightElement>
            <IconButton
              aria-label="Clear value"
              icon={<Xmark />}
              onClick={handleClear}
              size="xs"
            />
          </InputRightElement>
        )}
      </InputGroup>
    </Flex>
  );
};

export default TargetInputCell;
